import { Navigate } from 'react-router-dom';

import { APP_CONFIG_AGILE_SUITE } from '@hcs/app-configs';
import { useIsLoggedIn } from '@hcs/authn';

import { VIEW_PATHS_ACCESS_OM_DEMO } from '../../apps/access';

export const Landing = () => {
  const {
    data: { isLoggedIn },
  } = useIsLoggedIn();
  return isLoggedIn ? (
    <Navigate to={APP_CONFIG_AGILE_SUITE.rootPath} replace />
  ) : (
    <Navigate to={VIEW_PATHS_ACCESS_OM_DEMO.LOGIN} replace />
  );
};
